import { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import { mergeAuxSlugsNeededFromKeys } from '../config/auxCamposPipeline';

/**
 * Carga listas de auxiliares según los campo_key presentes en campos obligatorios.
 */
export function useAuxListsForCampos(isOpen, campoKeys) {
  const [auxLists, setAuxLists] = useState({});
  const inFlightRef = useRef(new Set());
  const loadedRef = useRef(new Set());
  const sig = JSON.stringify([...(campoKeys || [])].filter(Boolean).sort());

  useEffect(() => {
    if (!isOpen) return;
    let keys;
    try {
      keys = JSON.parse(sig);
    } catch {
      keys = [];
    }
    const slugs = mergeAuxSlugsNeededFromKeys(keys);
    slugs.forEach((slug) => {
      if (loadedRef.current.has(slug)) return;
      if (inFlightRef.current.has(slug)) return;
      inFlightRef.current.add(slug);
      api
        .get(`/auxiliares/${encodeURIComponent(slug)}`)
        .then((res) => {
          setAuxLists((prev) => ({ ...prev, [slug]: res.data?.data || [] }));
          loadedRef.current.add(slug);
        })
        .catch(() => {
          setAuxLists((prev) => ({ ...prev, [slug]: [] }));
          loadedRef.current.add(slug);
        })
        .finally(() => {
          inFlightRef.current.delete(slug);
        });
    });
  }, [isOpen, sig]);

  return auxLists;
}
